import Flickity from 'flickity';

export default class ProductHero {
  constructor() {
    this.$el = document.querySelector('.js-product-hero-carousel');
    if (!this.$el) return;
    this.totalSlides = this.$el.querySelectorAll('.js-product-hero-carousel-slide').length;
    this.init();
    window.addEventListener('resize', this.onResize.bind(this));
  }

  init() {
    if (window.innerWidth < 1024) {
      this.initCarousel();
      return;
    } else {
      if (this.totalSlides > 3) {
        this.initCarousel();
      } else {
        this.destroyCarousel();
        this.$el.classList.add('no-carousel');
      }
    }
  }

  onResize() {
    this.init();
  }

  initCarousel() {
    this.carousel = new Flickity(this.$el, {
      autoPlay: 4500,
      cellAlign: 'left',
      imagesLoaded: true,
      pageDots: true,
      pauseAutoPlayOnHover: true,
      prevNextButtons: false,
      contain: true,
      wrapAround: true,
    });
  }

  destroyCarousel() {
    if (this.carousel) {
      this.carousel.destroy();
    }
  }
}
